import { useState } from "react";
import CustomButton from "../../../../components/AddButton";
import AssignButton from "../../../../components/AddButton";
import CustomChip from "../../../../components/Chip/index";
import {
  edit,
  Plus,
  vehiclecontainer,
  vehicledriver,
  vehicleTruck,
} from "../../../../common/svg";
import AssignVehicle from "../../../../containers/Forms/Vehicles/master/Assignvehicle";
import Assignsurveyor from "../../../../containers/Forms/Surveyor/masterform/Assign Surveyor";
import AssignDriver from "../../../../containers/Forms/Driver/MasterForm/AssignDriver";
import SecureImage from "../../../../components/BucketImage/Image";
import Carousel from "../../../../components/Carousel";
import AssignContainer from "../../../../containers/Forms/ContainerForm/AssignContainer/AssignContainer";

interface Props {
  handleClick: () => void;
  container: string;
  vehicle: string;
  images: string[];
  tripData: any;
  vehcileDetails?: any;
  containerDetails?: any;
  surveyorDetails?: any;
  driverAssignments?: any;
  companyDetail: any;
  driverDetails?: any;
  onRefreshTripDetails?: () => void; // Callback to refresh trip details
}

const ContainerVehicleDetails: React.FC<Props> = ({
  handleClick,
  container,
  vehicle,
  images,
  tripData,
  vehcileDetails,
  surveyorDetails,
  driverAssignments,
  companyDetail,
  driverDetails,
  onRefreshTripDetails,
}) => {
  const [isSurveyorModalOpen, setIsSurveyorModalOpen] = useState(false);
  const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false);
  const [isDriverModalOpen, setIsDriverModalOpen] = useState(false);
  const [isContainerOpen, setIsContainerOpen] = useState(false);

  const surveyorAlreadyAssigned =
    Array.isArray(surveyorDetails) && surveyorDetails.length > 0;

  return (
    <div className="flex border-b border-dashed border-[#C1C1C1] w-full gap-4">
      {/* ================= Container Details ================= */}
      <div className="flex flex-col w-1/2 p-4 rounded-lg">
        <div className="flex items-center justify-between mb-4">
          <div className="flex gap-2 items-center">
            <p className="text-[#282828] text-[16px] font-[600] whitespace-nowrap">
              Container Details
            </p>
            <CustomChip
              text="Verified"
              backgroundColor="#ECFFEB"
              textColor="#04D900"
              borderColor="#04D900"
            />
          </div>
        </div>

        {/* Container Image & Buttons */}
        <div className="flex items-center gap-6 mt-4">
          <div className="flex-shrink-0">
            <SecureImage fileKey={container} alt="container" width="140px" />
          </div>
          <div className="flex flex-col gap-4">
            {!surveyorAlreadyAssigned && (
              <AssignButton
                label="Assign Surveyor"
                icon={vehicledriver}
                buttonClassName="w-[190px] rounded-[100px] bg-[#F4F4F4] h-[26px] border border-[#767575] whitespace-nowrap"
                labelClassName="!text-[#7E7E7E]"
                onClick={() => setIsSurveyorModalOpen(true)}
              />
            )}
            <AssignButton
              label="Assign Container"
              icon={vehiclecontainer}
              buttonClassName="w-[190px] rounded-[50px] bg-[#F4F4F4] h-[26px] border border-[#767575] whitespace-nowrap"
              labelClassName="!text-[#7E7E7E]"
              onClick={() => setIsContainerOpen(true)}
            />
          </div>
        </div>

        {/* Modals */}
        <Assignsurveyor
          isOpen={isSurveyorModalOpen}
          onClose={() => setIsSurveyorModalOpen(false)}
          tripID={tripData?.tripId || ""}
          bookingID={tripData?.bookingId || ""}
        />
        <AssignContainer open={isContainerOpen} setOpen={setIsContainerOpen} />
      </div>
      {/* Surveyor Details */}
      {surveyorAlreadyAssigned && (
        <div className=" flex flex-col gap-4 mt-4">
          {surveyorDetails.map((item: any, idx: number) => {
            const surveyor = item.surveyorData || item;
            const name =
              (surveyor.firstName || "") +
              (surveyor.lastName ? " " + surveyor.lastName : "");
            const contactNumber = surveyor.contactNumber || "";
            const liner = item.liner || "Ever Green Pvt Ltd";
            const companyDetail =
              item.companyDetail || surveyor.companyDetail || {};
            return (
              <div key={item.id || idx} className="p-2">
                {liner && (
                  <div className="text-[14px] text-[#7E7E7E]">
                    <p>Liner</p>
                    <p className="text-[#444FBD]">{liner}</p>
                  </div>
                )}
                <p className="text-[14px] text-[#7E7E7E]">Surveyor</p>
                <p className="text-[14px] text-[#444FBD] font-[600]">
                  {name.trim() || "Surveyor Name"}
                </p>
              </div>
            );
          })}
          {/* Show companyDetail if available, below surveyor name/contact */}
          {companyDetail &&
            (companyDetail.companyName ||
              companyDetail.phoneNumber ||
              companyDetail.email) && (
              <div className="mt-4 text-[14px] text-[#7E7E7E] whitespace-nowrap">
                <p>Company Name</p>
                <p className="text-[#444FBD]">
                  {companyDetail.companyName || ""}
                </p>
                <p>Phone Number</p>
                <p className="text-[#444FBD]">
                  {companyDetail.phoneNumber || ""}
                </p>
                <p>Email</p>
                <p className="text-[#444FBD]">{companyDetail.email || ""}</p>
              </div>
            )}
        </div>
      )}
      {/* ================= Vehicle Details ================= */}
      <div className="flex flex-col w-1/2 border-l border-[#C1C1C1] border-dashed p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex gap-2 items-center">
            <p className="text-[#282828] text-[16px] font-[600] leading-[27px] whitespace-nowrap">
              Vehicle Details
            </p>
            <CustomChip
              text="Verified"
              backgroundColor="#ECFFEB"
              textColor="#04D900"
              borderColor="#04D900"
            />
          </div>

          <div className="flex gap-2">
            <CustomButton label="" icon={edit} onClick={() => setIsVehicleModalOpen(true)} />
            <CustomButton
              label=""
              icon={Plus}
              onClick={() => setIsVehicleModalOpen(true)}
            />
          </div>
        </div>

        <AssignVehicle
          isOpen={isVehicleModalOpen}
          onClose={() => setIsVehicleModalOpen(false)}
          tripID={tripData?.tripId || ""}
          bookingID={tripData?.bookingId || ""}
          onVehicleAdded={onRefreshTripDetails}
          existingVehicles={vehcileDetails || []}
        />

        <div className="flex items-center gap-6">
          {!vehcileDetails?.length && (
            <>
              <SecureImage fileKey={vehicle} alt="vehicle" width="140px" />
              <div className="flex flex-col gap-4">
                <AssignButton
                  icon={vehicleTruck}
                  label="Assign Vehicle"
                  buttonClassName="w-[190px] rounded-[100px] bg-[#F4F4F4] h-[26px] border border-[#767575] whitespace-nowrap"
                  labelClassName="!text-[#7E7E7E]"
                  onClick={() => setIsVehicleModalOpen(true)}
                />
                <AssignButton
                  label="Assign Driver"
                  buttonClassName="w-[190px] rounded-[50px] bg-[#F4F4F4] h-[26px] border border-[#767575] whitespace-nowrap"
                  labelClassName="!text-[#7E7E7E]"
                  onClick={() => setIsDriverModalOpen(true)}
                />
              </div>
            </>
          )}
        </div>

        {vehcileDetails?.length > 0 && (
          <div className="mt-4">
            <Carousel
              items={vehcileDetails.map((item: any) => (
                <div key={item?.id || item?.vechicleData?.vehicleRegNo}>
                  <div className="flex h-[80px] gap-4">
                    <SecureImage
                      fileKey={vehicle}
                      alt="Vehicle"
                      width="138.66px"
                    />
                    <div className="mt-3">
                      <p className="text-[14px] text-[#7E7E7E]">
                        Owner/Executive
                      </p>
                      <p className="text-[14px] text-[#444FBD] font-[500]">
                        {item?.driverData?.executiveName || ""}
                      </p>
                      <div>
                        <p className="text-[14px] text-[#7E7E7E]">Company</p>
                        <button className="text-[14px] text-[#444FBD] font-[500]">
                          {item?.driverData?.companyName || ""}
                        </button>
                      </div>
                      <p className="text-[14px] text-[#282828]">
                        {item?.driverData?.phone || ""}
                      </p>
                      <p className="text-[14px] text-[#282828]">
                        {item?.driverData?.email || ""}
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col items-start mt-2">
                    <span className="w-[10px] h-[10px] bg-[#04D900] rounded-full mb-1"></span>
                    <p className="text-[14px] ml-6 text-[#444FBD] font-[600] leading-[22px]">
                      {item?.vechicleData?.vehicleRegNo}
                    </p>
                    <p className="text-[14px] text-[#7E7E7E]">
                      <span className="mr-2">Type</span>
                      <span className="text-[#282828] font-[500]">
                        {item?.vechicleData?.vehicleType}
                      </span>
                    </p>
                    <p className="text-[14px] text-[#7E7E7E]">
                      <span className="mr-2">Driver</span>
                      <span className="text-[#444FBD] font-[500]">
                        {item?.driverData?.driverName}
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            />
          </div>
        )}

        <AssignDriver
          isOpen={isDriverModalOpen}
          onClose={() => setIsDriverModalOpen(false)}
          tripID={tripData?.tripId || ""}
          bookingID={tripData?.bookingId || ""}
        />
      </div>
    </div>
  );
};

export default ContainerVehicleDetails;
